<template>
  <div>
    <v-card class="mb-4">
      <v-card-title class="text-h5">
        <h2>LO Votes List</h2>
      </v-card-title>

      <v-card-text class="pb-0">
        <!-- Loading -->
        <loading-spinner v-if="LoadingFlag" />

        <!-- No Records -->
        <div
          v-else-if="!tableData1 || !tableData1.length"
          class="no-results text-center pa-6"
        >
          <v-icon size="64" color="grey lighten-1">mdi-poll</v-icon>
          <p class="mt-4 mb-0 text-subtitle-1">No LO votes available</p>
        </div>

        <!-- Data Table -->
        <v-container v-else class="pa-4">
          <v-data-table
            :headers="tableheader1"
            :items="tableData1"
            :items-per-page="10"
            class="elevation-1"
          >
            <!-- LOM Name -->
            <template #[`item.LomName`]="{ item }">
              <span class="font-weight-medium">{{ item.LomName }}</span>
            </template>

            <!-- President Name -->
            <template #[`item.LomPresidentFullName`]="{ item }">
              <span>{{ item.LomPresidentFullName }}</span>
            </template>

            <!-- Aadhaar Verified -->
            <template v-slot:[`item.AadhaarVerified`]="{ item }">
              <v-chip :color="item.AadhaarVerifiedColor" draggable dark>{{
                item.AadhaarVerified
              }}</v-chip>
            </template>
            <!-- Voting Count -->
            <template v-slot:[`item.VotingCount`]="{ item }">
              <div class="d-flex align-center">
                <v-chip
                  :color="item.VotingCount == 0 ? 'red' : 'success'"
                  dark
                  small
                  class="mr-2"
                >
                  {{ item.VotingCount }}
                </v-chip>

                <!-- Eye button to open description -->
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="showDescription(item)"
                  class="ml-1"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="descriptionDialog"
      max-width="600px"
      scrollable
      content-class="rounded-dialog"
    >
      <v-card class="rounded-xl">
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-text-box</v-icon>
          Voting Description
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-4">
          <div class="popup-description" v-html="selectedDescription"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            elevation="2"
            @click="onCloseDescription"
            :loading="dialogClosing"
          >
            <v-icon left>mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import companyConfig from "@/company_config.json";
export default {
  name: "LoVotesList",
  props: {
    zone: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      LoadingFlag: false,
      Records: [],
      PresidentInfo: {},
      tableData1: [],
      tableheader1: [],
      descriptionDialog: false,
      selectedDescription: "",
      // per-row loading for actions like view description
      rowLoadingMap: {},
      dialogClosing: false,
    };
  },

  methods: {
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    showDescription(item) {
      // show per-row loader while opening dialog
      if (item && item.LomId) this.$set(this.rowLoadingMap, item.LomId, true);
      // Check if VotingDescription exists; fallback if missing
      this.selectedDescription =
        item.VotingDescriptionTxt1 || "<em>No description available.</em>";
      // small timeout to allow loader to show
      setTimeout(() => {
        this.descriptionDialog = true;
        if (item && item.LomId) this.$set(this.rowLoadingMap, item.LomId, false);
      }, 180);
    },
    viewSSCard(path) {
      if (path) {
        window.open(path, "_blank");
      } else {
        this.toast("error", "SS Card file not found");
      }
    },

    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      this.searchForm();
      // var url1 = "api/menu-details/show";
      // var condition1 = {
      //   UserInterface: 1,
      //   Module: "voting_rights",
      //   Action: "list_1",
      // };
      // this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
    },

    getLoVoteRecords() {
      console.log("searchForm called");

      this.SearchFlag = true;
      this.LoadingFlag = true;
      this.tableData1 = [];
      this.PresidentInfo = {};

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/reports/voting-rights/lists";
      var upload = {
        UserInterface: 2,
        Zone: this.zone,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = [];
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.SearchFlag = false;
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          thisIns.PresidentInfo = records.PresidentInfo;

          console.log({ PresidentInfo: thisIns.PresidentInfo });

          if (flag == 1) {
            thisIns.tableData1 = records.TableData;
            thisIns.tableheader1 = records.TableHeader;
            console.log({ tableheader1: thisIns.tableheader1 });
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          thisIns.LoadingFlag = false;
          console.log("error=" + error);
          thisIns.SearchFlag = false;
        });
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    previewData(tr) {
      console.log("previewData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    hideApprovalRecordPrompt(flag) {
      console.log("hideApprovalRecordPrompt called");
      console.log({ flag });
      this.approvalRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    onCloseDescription() {
      // show a tiny closing animation/loading before actually closing
      this.dialogClosing = true;
      setTimeout(() => {
        this.descriptionDialog = false;
        this.dialogClosing = false;
      }, 220);
    },
    approveData(tr) {
      console.log("approveData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.approvalRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to approve";
        this.toast("error", message);
      }
    },
  },

  mounted() {
    this.getLoVoteRecords();
  },
};
</script>

<style scoped>
.no-results {
  color: #757575;
}
.mb-4.v-card {
  overflow: visible;
}
.v-card-title {
  background: linear-gradient(90deg,#6a11cb,#2575fc);
  color: #fff;
  border-radius: 8px 8px 0 0;
}
.lo-table .v-data-table__wrapper table tr:hover {
  background: rgba(98, 0, 238, 0.04);
}
.action-icon-btn {
  transition: transform 140ms ease, box-shadow 140ms ease;
}
.action-icon-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.06);
}
.popup-description {
  line-height: 1.6;
}
.rounded-dialog {
  border-radius: 12px;
}

/* Data-table header and rows color tweaks */
.v-data-table-header th {
  background: linear-gradient(90deg, #f4f6fb, #e8eefc);
  color: #1f2d3d;
  font-weight: 600;
  border-bottom: 1px solid rgba(0,0,0,0.06);
}
.v-data-table .v-data-table__wrapper table tbody tr {
  background: #ffffff;
  transition: background-color 180ms ease, transform 120ms ease;
}
.v-data-table .v-data-table__wrapper table tbody tr:nth-child(odd) {
  background: #fbfcff;
}
.v-data-table .v-data-table__wrapper table tbody tr:hover {
  background: #f1f6ff !important;
  transform: translateY(-1px);
}

.v-chip[dark] {
  box-shadow: 0 6px 14px rgba(37,117,252,0.08);
}
</style>
